import { getAttendanceProjects } from '../../Thunks/HeyTraderThunks';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AttendanceProjectType } from '../../Types/HeyTraderTypes/Attendances/AttendanceProjectType';



interface AttendanceProjectSliceState {
    loader: boolean; // for refres pages and inital loadings
    attendanceProjectList: AttendanceProjectType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : AttendanceProjectSliceState = {
    loader: false,
    attendanceProjectList: [],
    errorDisplay: '',

}

// set state valu for api response
const attendanceProjectSlice = createSlice ({
    name: 'attendanceProjects',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAttendanceProjects.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAttendanceProjects.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAttendanceProjects.fulfilled, (state, action: PayloadAction<AttendanceProjectType[]>) => {
                    state.loader = false;
                    state.attendanceProjectList = action.payload;
                  })
    }
})

export const {} = attendanceProjectSlice.actions
export default attendanceProjectSlice.reducer
